import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwSaldosAlunos } from '../../../types/views/IVwSaldosAlunos';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para saldos dos alunos
 * Corresponde à view 'vw_saldos_alunos' no banco de dados
 */
export class ViewSaldosAlunos extends BaseMultiTenantService<IVwSaldosAlunos[]> {
     constructor() {
          super('vw_saldos_alunos', [], 'organizacao');
     }

     /**
      * Lista todos os saldos dos alunos
      */
     async getSaldosAlunos(organizationId: number): Promise<PostgrestResponse<IVwSaldosAlunos[]>> {
          return await this.getAllActive(organizationId);
     }

     /**
      * Busca saldo de um aluno específico
      */
     async getSaldoPorAluno(organizationId: number, alunoId: number): Promise<PostgrestResponse<IVwSaldosAlunos>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('id_aluno', alunoId)
               .single();
     }

     /**
      * Alunos que podem comprar hoje (dentro do limite diário)
      */
     async getAlunosPodemComprar(organizationId: number): Promise<PostgrestResponse<IVwSaldosAlunos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('pode_comprar_hoje', true)
               .order('saldo_disponivel', { ascending: false });
     }

     /**
      * Alunos com saldo baixo
      */
     async getAlunosSaldoBaixo(organizationId: number, limiteMinimo: number = 5): Promise<PostgrestResponse<IVwSaldosAlunos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .lt('saldo_disponivel', limiteMinimo)
               .order('saldo_disponivel', { ascending: true });
     }

     /**
      * Alunos por responsável
      */
     async getAlunosPorResponsavel(organizationId: number, responsavelId: number): Promise<PostgrestResponse<IVwSaldosAlunos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('id_responsavel', responsavelId)
               .order('aluno', { ascending: true });
     }

     /**
      * Total de saldo de todos os alunos
      */
     async getTotalSaldosAlunos(organizationId: number): Promise<number> {
          const { data } = await this.client
               .from(this.tableName)
               .select('saldo_disponivel.sum()')
               .eq(this.organizationIdField, organizationId);

          return data?.[0]?.sum || 0;
     }
}

export const viewSaldosAlunos = new ViewSaldosAlunos();
